/**
 * Internal dependencies
 */
import getRawDashboardLayout from './get-raw-dashboard-layout';
import getDashboardLayout from './get-dashboard-layout';

export default (state) => {
	const editedLayout = getDashboardLayout(state);
	const layout = getRawDashboardLayout(state);

	if (!layout || !editedLayout) {
		return false;
	}

	return JSON.stringify(editedLayout.items) !== JSON.stringify(layout.items);
};
